import { useGetUserTotalCommissions } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

export const useGetReferralBalance = () => {
  const id = useAuthStore((store) => store.id);

  // Get available commissions (READY status means available to withdraw)
  // We'll need to check what status values are available in the SDK
  const {
    data: balanceData,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetUserTotalCommissions({
    enabled: !!id,
    userId: id ?? 0,
    status: 'READY',
  });

  return {
    isLoading,
    isError,
    error,
    balance: balanceData?.total ?? 0,
    commissionsCount: balanceData?.count ?? 0,
    refetch,
  };
};
